module.exports = __webpack_public_path__ + "static/media/next.7c09fb6d.mp3";